module.exports = __webpack_public_path__ + "img/阵雨.703d9436.png";